import gql from "graphql-tag"; // eslint-disable-line import/no-named-as-default
import { print } from "graphql/language/printer";

/**
 * @todo - move to @lululemon/dsp-clients
 */
const carouselQuery: string = print(gql`
  query ($storeId: String!) {
    storeCarousel(storeId: $storeId) {
      store
      classes_images
      event_images
      event_rentals_images
      studio_note
      event_note
      rental_note
    }
  }
`);

export default carouselQuery;
